import React from "react";
import { Stack } from "@mui/material";
import PropTypes from "prop-types";
import Typography from "../../../designSystem/atoms/Typography";

import "./OrderDetailsFooter.scss";

import { ORDER_DETAILS } from "businesslogic/strings/ordersAuth";
const STRINGS = ORDER_DETAILS.cardFooter;

const OrderDetailsFooter = ({
  units,
  amount,
  frequency,
  instalments,
  startDate,
  endDate,
}) => (
  <Stack className="order-details-footer">
    {amount ? (
      <FooterRow
        keyName={STRINGS.amountKey.text}
        keyDataAid={STRINGS.amountKey.dataAid}
        value={amount}
        valueDataAid={STRINGS.amountValue.dataAid}
      />
    ) : null}
    {units ? (
      <FooterRow
        keyName={STRINGS.unitsKey.text}
        keyDataAid={STRINGS.unitsKey.dataAid}
        value={units}
        valueDataAid={STRINGS.unitsValue.dataAid}
      />
    ) : null}
    {frequency ? (
      <FooterRow
        keyName={STRINGS.frequencyKey.text}
        keyDataAid={STRINGS.frequencyKey.dataAid}
        value={frequency}
        valueDataAid={STRINGS.frequencyValue.dataAid}
      />
    ) : null}
    {instalments ? (
      <FooterRow
        keyName={STRINGS.instalmentsKey.text}
        keyDataAid={STRINGS.instalmentsKey.dataAid}
        value={instalments}
        valueDataAid={STRINGS.instalmentsValue.dataAid}
      />
    ) : null}
    {startDate ? (
      <FooterRow
        keyName={STRINGS.startDateKey.text}
        keyDataAid={STRINGS.startDateKey.dataAid}
        value={startDate}
        valueDataAid={STRINGS.startDateValue.dataAid}
      />
    ) : null}
    {endDate ? (
      <FooterRow
        keyName={STRINGS.endDateKey.text}
        keyDataAid={STRINGS.endDateKey.dataAid}
        value={endDate}
        valueDataAid={STRINGS.endDateValue.dataAid}
      />
    ) : null}
  </Stack>
);

const FooterRow = ({ keyName, keyDataAid, value, valueDataAid }) => (
  <Stack className="row-container">
    <Typography
      variant="body1"
      dataAid={keyDataAid}
      color={"foundationColors.content.primary"}
    >
      {keyName}
    </Typography>
    <Typography
      variant="body5"
      dataAid={valueDataAid}
      color={"foundationColors.content.secondary"}
    >
      {value}
    </Typography>
  </Stack>
);

OrderDetailsFooter.propTypes = {
  units: PropTypes.number,
  amount: PropTypes.string,
  frequency: PropTypes.string,
  instalments: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default OrderDetailsFooter;
